// Import model
import { DataviewCompanyResponse } from '../models/DataviewCompanyResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Company } from '../models/Company';
import { DataView } from '../models/DataView';
import { FilterCompanyRequest } from '../models/FilterCompanyRequest';

// Import dependency serializers (for complex types)
import { CompanySerializer } from './CompanySerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCompanyRequestSerializer } from './FilterCompanyRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCompanyResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCompanyResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCompanyResponse instance
   */
  static deserialize(json: string): DataviewCompanyResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCompanyResponse instance
   */
  static fromObject(obj: any): DataviewCompanyResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCompanyResponse');
    }


    const instance: DataviewCompanyResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CompanySerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCompanyRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCompanyResponse instances
   */
  static deserializeArray(json: string): DataviewCompanyResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCompanyResponse instance to a JSON string
   */
  static serialize(instance: DataviewCompanyResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCompanyResponse instance to a plain object
   */
  static toObject(instance: DataviewCompanyResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CompanySerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCompanyRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCompanyResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCompanyResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
